import React, { useContext, useState } from 'react';
import { ProfileImageBackground, Typography } from '@pwskills/rachnaui';
import PlayIcon from '@pwskills/rachnaui/Icons/Play';
import { companyImage } from '@/utils/common/env.constants';
import { useRouter } from 'next/router';
import Quotes from '../../Icons/courseDescription/Quotes';
import VideoModal from '../../VideoModal';
import { dataLayer } from '../../../../utils/common/dataLayer.utils';
import CourseDescriptionContext from '../../../../context/CourseDescriptionContext';

type Props = {
  testimonialType: string;
  name: string;
  description: string;
  designation: string;
  testimonialImage: string;
  videoLink?: string;
};

const Testimonial = (props: Props) => {
  const [modelOpen, setModelOpen] = useState<boolean>(false);
  const { testimonialType, description, videoLink, name, designation, testimonialImage } = props;

  const { courseDetails } = useContext(CourseDescriptionContext);
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const sendDataLayerEvent = (videoURL: string, section: string) => {
    const dataLayerObj = {
      event: 'video_click',
      section_name: section,
      course_id: courseDetails?._id,
      video_url: videoURL,
    };
    dataLayer(dataLayerObj);
  };
  if (testimonialType === 'video') {
    return (
      <div
        className={
          isDashboard
            ? 'w-full medium:!w-[300px]'
            : '!min-w-[93%] medium:!min-w-[360px] medium:!max-w-[360px]'
        }
      >
        <VideoModal
          title={name || ''}
          modalOpen={modelOpen}
          setModelOpen={setModelOpen}
          videoUrl={videoLink || ''}
          section="alumni_testimonies"
        />
        <div className="h-full flex flex-col rounded-b-[8px] group overflow-hidden">
          <div
            className={`relative h-full ${videoLink && 'cursor-pointer'}`}
            onClick={() => {
              if (videoLink) {
                setModelOpen(true);
                sendDataLayerEvent(videoLink, 'alumni_testimonies');
              }
            }}
            aria-hidden="true"
          >
            <img
              src={`${companyImage}/testimonialImage/${testimonialImage}`}
              alt={name}
              className="w-full h-full rounded-t object-cover transition-all group-hover:scale-110"
            />
            <div className="absolute w-full h-full translate-y-[-50%] rounded-t top-[50%] left-[50%] translate-x-[-50%] bg-black opacity-[0.3]" />
            <PlayIcon className="w-[37px] h-[37px] text-white absolute bottom-[3px] left-[10px] py-2 pr-[6px] pl-[8px]" />
            <div className="text-right text-white absolute bottom-[3px] right-[10px] py-2  pl-[8px]">
              <Typography variant="bold" component="body-regular" className="text-inherit">
                {name}
              </Typography>
              <Typography variant="regular" component="body-regular" className="text-inherit">
                {designation}
              </Typography>
            </div>
          </div>
          <Typography
            component="body-regular"
            variant="regular"
            className="p-5 bg-orange-500 text-white rounded-b-[8px] relative z-10"
          >
            {description}
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${
        isDashboard
          ? 'w-full medium:!w-[300px]'
          : '!min-w-[93%] medium:!min-w-[360px] medium:!max-w-[360px]'
      } rounded-[8px] border   border-stroke-200 p-5 bg-white flex flex-col justify-between`}
    >
      <div>
        <Quotes className="mb-4" />
        <Typography component="body-regular" variant="regular" className="text-gray-850">
          {description}
        </Typography>
      </div>
      <div>
        <div className="border border-dashed border-stroke-300 my-[27px]" />
        <div className="flex gap-[10px] items-center ">
          {testimonialImage ? (
            <img
              src={`${companyImage}/testimonialImage/${testimonialImage}`}
              alt={name}
              width={42}
              height={42}
              className="object-cover w-[40px] h-[40px] rounded-[50%]"
            />
          ) : (
            <ProfileImageBackground firstName={name} lastName="" />
          )}
          <div>
            <Typography component="body-regular" variant="semi-bold" className="text-gray-850">
              {name}
            </Typography>
            <Typography className="text-gray-650" component="body-regular" variant="regular">
              {designation}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
